import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/PdpRespQrCode.scss';

export const PdpRespQrCode = ({ className, itemId }) => {
    const src = `https://node-lambda.1stdibs.com/prod/qrcode.png?item=${itemId}&width=400&addlQuery=utm_source%3Dqr-code%26utm_medium%3Demail%26utm_campaign%3Dprint-page`;

    return <img className={`${className} ${styles.qrCode}`} src={src} />;
};

PdpRespQrCode.propTypes = {
    className: PropTypes.string,
    itemId: PropTypes.string.isRequired,
};
